/**
 * @typedef {Object} iprModel
 * @property {string} toothGumType
 * @property {number} stageNumber
 * @property {number} iprNumber
 * @property {Object} startPosition
 * @property {Object} endPosition
 * @property {number} iprValue
 * @property {Float32Array} vertices
 */

import {
  TOOTH_GUM_TYPE_KEY,
  TOOTH_RAW_TYPE,
  TOOTH_STAGE_NUMBER_KEY,
} from "../constant/toothConstant";
import toothMatrixDB from "../db/toothMatrixDB";
import toothStageRawDB from "../db/toothStageRawDB";
import { getIPREndPosition, getIPRStartPosition } from "../util/iprUtil";
import { addPerform } from "../../tools/perform-tool";

/**
 * @type {iprModel[]}
 */
const iprModelMapSingle = {};
const iprModelListSingle = [];

const loadIPRModelList = async () => {
  const iprRawDOList = toothStageRawDB.getToothStageRawDOListByRawType(
    TOOTH_RAW_TYPE.IPR
  );

  for (let i = 0; i < iprRawDOList.length; i++) {
    const iprRawDO = iprRawDOList[i];

    const { stageNumber, toothGumType, rawData } = iprRawDO;

    const key = `${TOOTH_GUM_TYPE_KEY}:${toothGumType}.${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}`;
    const iprModelList = iprModelMapSingle[key] || [];

    for (let j = 0; j < rawData.length; j++) {
      const iprData = rawData[j];
      const iprNumber = j;
      const { IPRValue, centerPosition, tooth1, tooth2, vertices } = iprData;
      const tooth1Matrix =
        toothMatrixDB.getToothMatrixDOByStageNumberAndToothGumTypeAndToothIndex(
          stageNumber,
          toothGumType,
          tooth1
        );
      const tooth2Matrix =
        toothMatrixDB.getToothMatrixDOByStageNumberAndToothGumTypeAndToothIndex(
          stageNumber,
          toothGumType,
          tooth2
        );

      if (!tooth1Matrix || !tooth2Matrix) {
        throw new Error(
          `Tooth matrix not found for toothGumType: ${toothGumType}, stageNumber: ${stageNumber}, tooth1: ${tooth1}, tooth2: ${tooth2}`
        );
      }

      const startPosition = getIPRStartPosition(centerPosition);
      const endPosition = getIPREndPosition(
        tooth1Matrix,
        tooth2Matrix,
        centerPosition,
        toothGumType
      );

      const iprModel = {
        beginToothIndexNumber: tooth1,
        endToothIndexNumber: tooth2,
        toothGumType,
        stageNumber,
        iprNumber,
        startPosition,
        endPosition,
        iprValue: IPRValue,
        vertices,
      };

      iprModelList.push(iprModel);
      iprModelListSingle.push(iprModel);
    }

    iprModelMapSingle[key] = iprModelList;
  }
};

const getIPRModelListByStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const key = `${TOOTH_GUM_TYPE_KEY}:${toothGumType}.${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}`;
  return iprModelMapSingle[key];
};

const getIPRModelList = () => {
  return iprModelListSingle;
};

export default {
  loadIPRModelList,
  getIPRModelList,
  getIPRModelListByStageNumberAndToothGumType,
};
